import React from 'react';
import style from './style';
import Header from '../Header';
import EAIcon from '../../../../../../components/common/EAIcon';
import EAColorIcon from '../../../../../../components/common/EAColorIcon';
import i18next from 'i18next';
import SearchTiersContact from '../../../../AddContext/components/Add/SearchTiersContact';
import EAButton from '../../../../../../components/common/EAButton';

const Referents = ({
  referents,
  tpToAdd,
  addContact,
  deleteReferent,
  onCancel,
  onValidate,
}) => {
  const { classes } = style();

  return (
    <>
      {tpToAdd && (
        <div className={classes.root}>
          <Header tp={tpToAdd} />
          <div className={classes.referentsWrapper}>
            <div className={classes.partTitle}>
              <EAColorIcon icon={'context/contextTiers/referent'} />
              <span>{i18next.t(`context.addTiers.ajouterReferent`)}</span>
            </div>
         {/*   <div className={classes.referentText}>
              {i18next.t(`context.addTiers.ajouterReferentText`)}
            </div>*/}
            <div className={classes.referentInputWrapper}>
              <SearchTiersContact
                thirdpartyId={tpToAdd.thirdpartyId}
                addContact={addContact}
              />
            </div>
            {referents.length ? (
              <div>
                <div className={classes.referentListTitle}>
                  {i18next.t('context.addTiers.referentsTiers')}
                </div>
                <div className={classes.referentList}>
                  {referents.map((r) => (
                    <div className={classes.referentItem} key={r}>
                      <EAIcon icon={'context/contextTiers/referent2'} />
                      <div className={classes.referentEmail}>{r}</div>
                      <div
                        onClick={() => deleteReferent(r)}
                        className={classes.deleteReferentButton}
                      >
                        {i18next.t('context.addTiers.retirer')}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
          <div className={classes.buttons}>
            <EAButton
              onClick={onCancel}
              content={i18next.t('cancel')}
              colorVariant={'secondary'}
            />
            <EAButton
              onClick={onValidate}
              content={i18next.t('context.addTiers.saveThisTp')}
              colorVariant={'primary'}
              customStyle={{
                marginLeft: '14px',
              }}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Referents;
